import styled from 'styled-components';

export const SupStyled = styled.sup`
  color: var(--ds-text-danger, var(--ds-fb-text-danger));
  vertical-align: top;
  font-size: 14px;
`;
